import PrimaryMessageContentSection from '../primary-message/components/PrimaryMessageContentSection';
import HiddenMessage from './HiddenMessage';
import { WHATSAPP_GENERIC_CHANNEL_ID } from 'conversations-message-history/common-message-format/constants/genericChannelIds';
import { getMessageHeaderAttachment } from 'conversations-message-history/attachments/operators/headerAttachmentGetters';
import { getQuickRepliesAttachment } from 'conversations-message-history/attachments/operators/quickRepliesAttachmentGetters';
import { getStatus
// @ts-expect-error module not typed
} from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import { QUARANTINED } from 'conversations-message-history/common-message-format/constants/statusTypes';
import QuickRepliesAttachment from '../attachments/QuickRepliesAttachment';
import QuarantinedMessageAlert from './QuarantinedMessageAlert';
// @ts-expect-error module not typed
import { hasTextContent } from 'conversations-message-history/web/common-message/operators/hasTextContent';
// @ts-expect-error module not typed
import { hasImageContent } from 'conversations-message-history/web/common-message/operators/hasImageContent';
import { getContentAttachments, getMessageDirection, getGenericChannelId } from 'conversations-message-history/common-message-format/operators/commonMessageGetters';
import { List as ImmutableList } from 'immutable';
import { isEmailCMF
// @ts-expect-error module not typed
} from 'conversations-message-history/common-message-format/operators/cmfComparators';
import { getFilteredAttachments, hasRenderableAttachments
// @ts-expect-error module not typed
} from 'conversations-message-history/attachments/operators/imageAttachmentFilters';
// @ts-expect-error module not typed
import { getMessageId } from 'conversations-message-history/message-history/operators/getMessageId';
import { LAST } from 'conversations-message-history/constants/messagePositionDescriptors';
import DirectReplyOriginalMessagePreview from '../v2/message-data/direct-reply/DirectReplyOriginalMessagePreview';
import InlineAttachments from '../attachments/InlineAttachments';
import CommonMessageContent from './CommonMessageContent';
import WorkflowGeneratedUserHeaderAttachment from '../workflow-generated-user-message/components/WorkflowGeneratedUserHeaderAttachment';
import { INCOMING } from 'conversations-message-history/common-message-format/constants/messageDirections';
// @ts-expect-error module not typed
import { getCallMetadataAttachment } from 'conversations-message-history/call/operators/callMetadataAttachmentGetters';
import TimelineCallMetadata from 'conversations-calling-message/timeline-call-metadata/components/TimelineCallMetadata';
import NoContentLabel from 'conversations-message-history/atoms/NoContentLabel';
import { getLocationAttachment } from 'conversations-message-history/attachments/operators/locationAttachmentGetters';
import { getContactAttachments } from 'conversations-message-history/attachments/operators/contactAttachmentGetters';
import { getUnsupportedContentAttachment } from 'conversations-message-history/attachments/operators/unsupportedContentAttachmentGetters';
import { getAsyncAttachmentState } from '../attachments/operators/getAsyncAttachmentState';
import { Alert } from 'foundations-components/transitional/components/Alert';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { CitationSourcesAttachments } from '../attachments/CitationSourcesAttachments';
import get from 'transmute/get';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AttachmentDeletedAlert = () => {
  return /*#__PURE__*/_jsx(PrimaryMessageContentSection, {
    canExpand: false,
    children: /*#__PURE__*/_jsx(Alert, {
      type: "warning",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-message-history.common-message.attachmentDeletedMessage"
      })
    })
  });
};
AttachmentDeletedAlert.displayName = 'AttachmentDeletedAlert';
const CallMetadataAttachmentFooterSection = ({
  message,
  ungatedForNextBestActions,
  ungatedForCopilotPreview,
  ungatedForChatspot,
  ungatedForAutogenerateCopilotCallSummary,
  ungatedForOmnichannelCallSummaryAiSkill
}) => {
  const callMetadata = getCallMetadataAttachment(message);
  if (callMetadata) {
    return /*#__PURE__*/_jsx(PrimaryMessageContentSection, {
      children: /*#__PURE__*/_jsx(TimelineCallMetadata, {
        ungatedForNextBestActions: !!ungatedForNextBestActions,
        ungatedForCopilotPreview: !!ungatedForCopilotPreview,
        ungatedForChatspot: !!ungatedForChatspot,
        ungatedForAutogenerateCopilotCallSummary: !!ungatedForAutogenerateCopilotCallSummary,
        ungatedForOmnichannelCallSummaryAiSkill: !!ungatedForOmnichannelCallSummaryAiSkill,
        message: message,
        callMetadata: callMetadata
      })
    });
  }
  return null;
};
CallMetadataAttachmentFooterSection.displayName = 'CallMetadataAttachmentFooterSection';
const HiddenMessageContainer = ({
  hiddenMessage
}) => {
  return /*#__PURE__*/_jsx(PrimaryMessageContentSection, {
    children: hiddenMessage || /*#__PURE__*/_jsx(HiddenMessage, {})
  });
};
HiddenMessageContainer.displayName = 'HiddenMessage';
const QuickReplies = ({
  message
}) => {
  const messageDirection = getMessageDirection(message);
  const quickRepliesAttachment = getQuickRepliesAttachment(message);
  if (!quickRepliesAttachment || messageDirection === INCOMING) {
    return null;
  }
  return /*#__PURE__*/_jsx(QuickRepliesAttachment, {
    quickRepliesAttachment: quickRepliesAttachment
  });
};
QuickReplies.displayName = 'QuickReplies';
const MessageHeaderAttachment = ({
  message,
  fileAttachments
}) => {
  const headerAttachment = getMessageHeaderAttachment(message);
  const genericChannelId = getGenericChannelId(message);
  if (!headerAttachment) {
    return null;
  }
  return /*#__PURE__*/_jsx(WorkflowGeneratedUserHeaderAttachment, {
    headerAttachment: headerAttachment,
    fileAttachments: fileAttachments,
    genericChannelId: genericChannelId
  });
};
MessageHeaderAttachment.displayName = 'MessageHeaderAttachment';
const MessageContentContainer = ({
  message,
  fetchReplies,
  messageReplyIsLoading,
  plainTextMode,
  handleFetchImageProcessingStatus,
  shouldDisplayBanner,
  numberOfProcessingImages,
  fileAttachments,
  ungatedForNextBestActions,
  ungatedForCopilotPreview,
  ungatedForChatspot,
  ungatedForAutogenerateCopilotCallSummary,
  ungatedForOmnichannelCallSummaryAiSkill,
  fileAttachmentsForThread,
  indexedAsyncFileAttachments
}) => {
  const callMetadata = getCallMetadataAttachment(message);
  if (callMetadata) {
    return /*#__PURE__*/_jsx(CallMetadataAttachmentFooterSection, {
      message: message,
      ungatedForNextBestActions: ungatedForNextBestActions,
      ungatedForCopilotPreview: ungatedForCopilotPreview,
      ungatedForChatspot: ungatedForChatspot,
      ungatedForAutogenerateCopilotCallSummary: ungatedForAutogenerateCopilotCallSummary,
      ungatedForOmnichannelCallSummaryAiSkill: ungatedForOmnichannelCallSummaryAiSkill
    });
  }
  const genericChannelId = getGenericChannelId(message);
  const contentAttachments = fileAttachments && fileAttachments.size ? getContentAttachments(message, fileAttachments) : ImmutableList();
  const hasMessageContent = hasTextContent(message) || hasImageContent(message);
  const hasInlineAttachments = !isEmailCMF(message) && hasRenderableAttachments(contentAttachments);
  const asyncAttachmentState = fileAttachmentsForThread && indexedAsyncFileAttachments && getAsyncAttachmentState({
    message,
    loadedFileAttachments: fileAttachmentsForThread,
    indexedAsyncFileAttachments
  });
  const shouldRenderMessageSection = hasMessageContent || hasInlineAttachments;
  const locationMetadata = getLocationAttachment(message);
  const contactsMetadata = getContactAttachments(message);
  const unsupportedContent = getUnsupportedContentAttachment(message);
  const footerAttachments = isEmailCMF(message) ? fileAttachments : getFilteredAttachments({
    fileAttachments: contentAttachments,
    canRender: false
  });
  const shouldRenderAttachmentsFooterSection = Boolean(locationMetadata) || Boolean(contactsMetadata) || Boolean(unsupportedContent) || footerAttachments && footerAttachments.size > 0;
  const isLoadingAttachment = asyncAttachmentState && asyncAttachmentState.isLoadingAttachment;
  const isMissingAttachment = asyncAttachmentState && asyncAttachmentState.isMissingAttachment;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(MessageHeaderAttachment, {
      message: message,
      fileAttachments: fileAttachments
    }), /*#__PURE__*/_jsx(CommonMessageContent, {
      fetchReplies: fetchReplies,
      message: message,
      messageReplyIsLoading: messageReplyIsLoading,
      plainTextMode: plainTextMode,
      handleFetchImageProcessingStatus: handleFetchImageProcessingStatus,
      shouldDisplayBanner: shouldDisplayBanner,
      numberOfProcessingImages: numberOfProcessingImages,
      genericChannelId: genericChannelId
    }), /*#__PURE__*/_jsx(CitationSourcesAttachments, {
      message: message
    }), /*#__PURE__*/_jsx(QuickReplies, {
      message: message
    }), isMissingAttachment && /*#__PURE__*/_jsx(AttachmentDeletedAlert, {}), !shouldRenderMessageSection && !shouldRenderAttachmentsFooterSection && !isLoadingAttachment && /*#__PURE__*/_jsx(PrimaryMessageContentSection, {
      children: /*#__PURE__*/_jsx(NoContentLabel, {})
    })]
  });
};
MessageContentContainer.displayName = 'MessageContentContainer';
const CommonMessageSection = ({
  hiddenBy,
  hiddenMessage,
  message,
  fileAttachments,
  positionDescriptors,
  lastMessageId,
  directReplyState,
  fetchReplies,
  messageReplyIsLoading,
  plainTextMode = false,
  handleFetchImageProcessingStatus,
  shouldDisplayBanner,
  numberOfProcessingImages,
  fileAttachmentsForThread,
  indexedAsyncFileAttachments,
  ungatedForAutogenerateCopilotCallSummary,
  ungatedForOmnichannelCallSummaryAiSkill
}) => {
  const genericChannelId = getGenericChannelId(message);

  //remove header attachment from rest of the file attachments
  const contentAttachments = fileAttachments && fileAttachments.size ? getContentAttachments(message, fileAttachments) : ImmutableList();
  const shouldRenderInlineAttachments = !isEmailCMF(message) && hasRenderableAttachments(contentAttachments);
  const renderableAttachments = shouldRenderInlineAttachments && getFilteredAttachments({
    fileAttachments: contentAttachments,
    canRender: true
  });
  const isLast = positionDescriptors.includes(LAST) || lastMessageId === getMessageId(message);
  const actorId = get('actorId', hiddenBy || {}) || '';
  const hasSystemActorType = actorId === null || actorId === void 0 ? void 0 : actorId.startsWith('S');
  return /*#__PURE__*/_jsx(_Fragment, {
    children: actorId && !hasSystemActorType ? /*#__PURE__*/_jsx(HiddenMessageContainer, {
      hiddenMessage: hiddenMessage
    }) :
    // TODO - Make quarantined message generic once there's
    // an easy way to grab a friendly name based off of ID

    genericChannelId === WHATSAPP_GENERIC_CHANNEL_ID && getStatus(message) === QUARANTINED ? /*#__PURE__*/_jsx(PrimaryMessageContentSection, {
      children: /*#__PURE__*/_jsx(QuarantinedMessageAlert, {})
    }) : /*#__PURE__*/_jsxs(PrimaryMessageContentSection, {
      canExpand: true,
      isLastMessage: isLast,
      genericChannelId: genericChannelId,
      children: [directReplyState && /*#__PURE__*/_jsx(DirectReplyOriginalMessagePreview, {
        directReplyState: directReplyState
      }), /*#__PURE__*/_jsx(MessageContentContainer, {
        message: message,
        fetchReplies: fetchReplies,
        messageReplyIsLoading: messageReplyIsLoading,
        plainTextMode: plainTextMode,
        handleFetchImageProcessingStatus: handleFetchImageProcessingStatus,
        shouldDisplayBanner: shouldDisplayBanner,
        numberOfProcessingImages: numberOfProcessingImages,
        fileAttachments: fileAttachments,
        fileAttachmentsForThread: fileAttachmentsForThread,
        indexedAsyncFileAttachments: indexedAsyncFileAttachments,
        ungatedForAutogenerateCopilotCallSummary: ungatedForAutogenerateCopilotCallSummary,
        ungatedForOmnichannelCallSummaryAiSkill: ungatedForOmnichannelCallSummaryAiSkill
      }), shouldRenderInlineAttachments && /*#__PURE__*/_jsx(InlineAttachments, {
        fileAttachments: renderableAttachments,
        genericChannelId: genericChannelId
      })]
    })
  });
};
CommonMessageSection.displayName = 'CommonMessageSection';
export default CommonMessageSection;